export default {
  data() {
    return {
      TFA_SETTING: {
        NO_USE: "NO_USE",
        ADMIN_FORCE: "ADMIN_FORCE",
        CLIENT_FORCE: "CLIENT_FORCE",
        MEMBER_SELECT: "MEMBER_SELECT"
      },
    }
  },
  methods: {
    isTfaNoUse(tfaSetting) {
      return (tfaSetting == this.TFA_SETTING.NO_USE)
    },
    isTfaForceForClient(tfaSetting) {
      return (tfaSetting == this.TFA_SETTING.ADMIN_FORCE)
    },
    isTfaForceForMember(tfaSetting) {
      return (
        tfaSetting == this.TFA_SETTING.ADMIN_FORCE ||
        tfaSetting == this.TFA_SETTING.CLIENT_FORCE
      )
    },
    isTfaClientSelect(tfaSetting) {
      return (
        tfaSetting == this.TFA_SETTING.CLIENT_FORCE ||
        tfaSetting == this.TFA_SETTING.MEMBER_SELECT
      )
    },
  }
}
